// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Link, Stack, Typography } from '@mui/material';

export function SiteNotFound() {
  return (
    <Stack padding={2}>
      <Typography variant="subtitle1">Site not found</Typography>
      <Typography variant="body2">
        This location does not exist. If you think that you should have a
        location here, please contact&nbsp;
        <Link
          href="mailto:support@hardfin.com"
          color="inherit"
          fontWeight="bold"
        >
          support@hardfin.com
        </Link>
        &nbsp;and let us know that your location appears to be missing.
      </Typography>
    </Stack>
  );
}
